export default "__VITE_ASSET__BuWn0YTu__"